<template>
  <div class="list">
    <ul class="hander">
       <li><van-icon name="arrow-left" @click="goBack" class='nav_goback' /></li>
      <li :class="type >=6 && 'on'" @click="selType(10)">全部</li>
      <li :class="type == 1 && 'on'" @click="selType(1)">待付款<div class="tag" v-if="myOrderData.a">{{myOrderData.a}}</div></li>
      <li :class="type == 2 && 'on'" @click="selType(2)">待发货<div class="tag" v-if="myOrderData.b">{{ myOrderData.b}}</div></li>
      <li :class="type == 3 && 'on'" @click="selType(3)">待收货<div class="tag" v-if="myOrderData.c">{{ myOrderData.c}}</div></li>
      <li :class="type == 4 && 'on'" @click="selType(4)">待评价<div class="tag" v-if="myOrderData.d">{{ myOrderData.d}}</div></li>
      <li :class="type == 5 && 'on'" @click="selType(5)">售后中</li>
    </ul>
    <!-- <div
      class="listbox"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      :infinite-scroll-distance="10">
      
    </div> -->


    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getOrderList"
    >
      <div v-if="!list.length" style="padding-top:200px;color:#999;text-align:center;font-size:18px;">暂无数据</div>
      <div class="order_li" v-for="item in list" :key="item.id">
        <div class="top">
          <span class="number">
            订单号：
            <i>{{ item.sn }}</i>
          </span>
          <span
            class="status"
          >{{ item.status == 0 && '待商家设置运费' || item.status == 1 && '待付款' || item.status == 2 && '待发货' || item.status == 3 && '待收货' || item.status == 4 && '待评价' || item.status == 5 && '已完成' || item.status == 6 && '退款中' || item.status == 7 && '已退款'}}</span>
        </div>
        <div class="goodsBox">
          <Goods :goods="el" v-for="el in item._child" :key="el.id" />
        </div>
        <div class="bottom">
          <span v-if="item.logistics_fee != 0">邮费: ￥{{ item.logistics_fee }}</span>
          <span>共{{ item.num }}件 共计: ￥{{ item.money || 0 }}</span>
          <div class="s_li">
            <div class="item" v-if="item.status == 1" @click="cancel(item.id)">取消订单</div>
            <div class="item" v-if="item.status == 1&& item.is_finance != 1" @click="pay(item.id,item.source)">去支付</div>
            <div class="item" v-if="item.source == 1 && item.status == 2  || item.source == 2 && item.status == 2" @click="tuikuan(item.id)">申请退款</div>
            <div class="item" v-if="item.status == 3 && !item.is_sale" @click="receipt(item.id)">确认收货</div>
            <div class="item" v-if="item.status > 3 && item.status < 6" @click="delOrder(item.id)">删除订单</div>
            <!-- <div class="item" v-if="item.status == 4" @click="eva(item.id)">立即评价</div> -->
            <div class="item" v-if="item.status > 0" @click="toDetail(item.id)">订单详情</div>
          </div>
        </div>
      </div>
    
    
    
    </van-list>


    <van-action-sheet v-model="show_action" :actions="actions" @select="onSelect" />
    <div class="pwd" v-if="showPwd" @click.stop="show_pwd">
      <div class="innerbox" @click.stop>
        <van-password-input
          :value="password"
          info="密码为 6 位数字"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />

        <!-- 数字键盘 -->
        <van-number-keyboard
          :show="showKeyboard"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Goods from "../../component/goods/GoodsOrder";
import merge from "webpack-merge";
export default {
  components: {
    Goods
  },
  data() {
    return {
      type: 0,
      page: 1,
      list: [],
      noData: false,
      int: null,
      show_action: false,
      actions: [
        { name: "微信支付", index: 0 },
        { name: "余额支付", index: 1 },
        { name: "取消", index: 2 }
      ],
      selId: null,
      password: "",
      showKeyboard: true,
      showPwd: false,
      loading:false,
      finished:false,
      myOrderData:null
    };
  },
  created() {
    this.type = this.$route.query.type;
    // this.getOrderList();
    this.$http({
      url: "getDefaultReceive"
    }).then(res => {
      this.$store.commit("setUserVIP", {
        is_password: res.is_password,
        is_vip: res.is_vip
      });
      this.is_password = res.is_password;
    });
    this.getMyOrderData()
    // if (!this.$store.state.isIos) {
    //   let url = location.href.split("#")[0];
    //   this.$http({
    //     url: `jsApi`,
    //     data: {
    //       url
    //     }
    //   }).then(res => {
    //     this.$wx.config({
    //       debug: true,
    //       appId: res.jsdata.appId,
    //       timestamp: res.jsdata.timestamp,
    //       nonceStr: res.jsdata.nonceStr,
    //       signature: res.jsdata.signature,
    //       jsApiList: ["chooseWXPay"]
    //     });
    //   });
    // }
  },
  methods: {
    tuikuan(id){
      this.$dialog.confirm({
          message: "是否申请退款"
        }).then(()=>{
          this.$http({
            url: "refund",
            data: {
              id
            }
          }).then(res => {
            if(res != '成功') return this.$toast('res')
            this.$toast("退款成功")

            this.list = this.list.filter(item=>item.id != id )
            
          })
        })

    },
    onInput(key) {
      this.password = (this.password + key).slice(0, 6);
      if (this.password.length == 6) {
        let id = this.selId;

        let list = this.list;

        let [data] = list.filter(item => item.id == id);
        let receive_id = JSON.parse(data.receive_json).id;
        this.$http({
          url: "payByAmount",
          data: {
            password: this.password,
            receive_id,
            id
          }
        }).then(res => {
          if (res == "密码错误") this.$toast("密码错误，请重新输入");
        });
      }
    },
    show_pwd() {
      this.password = "";
      this.showPwd = false;
    },
    onDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },
    // 申请售后
    serves(id) {
      this.$router.push({ name: "asApply", params: { id } });
    },

    // 确认收货
    receipt(id) {
      this.$dialog
        .confirm({
          message: "是否确认收货"
        })
        .then(() => {
          this.$http({
            url: "surGet",
            data: {
              id
            }
          }).then(res => {
            let list = this.list;
            let newList = list.filter(item => item.id !== id);
            this.list = newList;
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取消订单
    cancel(id) {
      this.$dialog
        .confirm({
          message: "是否取消订单"
        })
        .then(() => {
          this.$http({
            url: "cancelOrders",
            data: {
              id
            }
          }).then(res => {
            let list = this.list;
            let newList = list.filter(item => item.id !== id);
            this.list = newList;
          });
        });
    },
    // 去支付
    pay(id,source) {

      if(source == 1) return this.$router.push({ name: "orderCommit", query: { id } });

      if(source == 2) return this.$router.push({name:'Corder',query: { id } })

      // 弹窗 微信支付  余额支付
      
    },
    onSelect(e) {
      let { index } = e;

      if (index == 0) {
        // 微信支付
        // 获取支付参数
        this.$http({
          url: "surePay",
          data: {
            id: this.selId
          }
        }).then(res => {
          /* TODO */
          this.$wx.chooseWXPay({
            timestamp: res.timeStamp,
            nonceStr: res.nonceStr,
            package: res.package,
            signType: res.signType,
            paySign: res.paySign,
            success: () => {
              alert("");
            }
          });
        });
      } else if (index == 1) {
        // 余额支付

        this.showPwd = true;
      } else {
        // 取消
        this.selId = null;
      }
      this.show_action = false;
    },

    // 删除订单
    delOrder(id) {

      this.$dialog.confirm({
        message:'是否删除'
      }).then(()=>{
        this.$http({
        url: "delOrder",
        data: {
          id
        }
      }).then(res => {
        let list = this.list;
        let newList = list.filter(item => item.id !== id);
        this.list = newList;
        this.$toast('删除成功')
      });


      })


      
    },
    // 评价
    eva(id) {
      this.$router.push({ name: "orderEva", params: { id } });
    },
    // 订单详情页
    toDetail(id) {
      this.$router.push({ name: "orderDetail", query: { id } });
    },
    getOrderList() {
      this.$http({
        url: "myOrderList",
        data: {
          type: this.type,
          page: this.page
        }
      }).then(res => {
        if (res._list.length == 0){
          // this.noData = true
          this.finished = true
          this.loading = false
          
          return
        }
        
        this.page = ++res.nowPage;
        this.loading = false
        
        let orderList = res._list;
        
        orderList.forEach(item => {
          let is_sale = false
          let num = 0;
          let childList = item._child;
          childList.forEach(el => {
            num += el.num;
            el.status = item.status;
            el.type = item.type
            if(el.orders_service_id) is_sale = true
          });
          item.num = num;
          item.is_sale = is_sale
        });

        this.list = res.nowPage == 1 ? orderList : this.list.concat(orderList);
      });
    },
    selType(type) {
      this.type = type;
      this.page = 1;
      this.noData = false;
      this.list = [];
      clearInterval(this.int);
      this.getOrderList();
      this.$router.replace({
        query: merge(this.$route.query, { type: this.type })
      });
    },
    async getMyOrderData(){
      let data =await this.$http({url:'my'})
      console.log(data)
      this.myOrderData = data
    }
    // loadMore() {
    //   return;
    //   if (this.noData) return;
    //   this.loading = true;
    //   this.int = setTimeout(() => {
    //     this.getOrderList();
    //     this.loading = false;
    //   }, 2500);
    // }
  }
};
</script>
<style lang="less" scoped>
.list {
  .nav_goback{
    padding-top: 10px;
    font-size: 32px;
    
  }
  .hander {
    width: 100%;
    height: 81px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    li {
      font-size: 28px;
      color: #666;
      position: relative;
      .tag{
        width: 30px;
        height: 30px;
        font-size: 24px;
        line-height: 30px;
        position: absolute;
        color: #fff;
        top: -10px;
        right: -30px;
        border-radius: 50%;
        overflow: hidden;
        background: #e42129;
        text-align: center;
      }
    }
    .on {
      color: #e42129;
    }
  }
  .order_li {
    width: 100%;
    padding: 0 24px;
    background-color: #fff;
    box-sizing: border-box;
    margin-bottom: 20px;
    .top {
      display: flex;
      align-items: center;
      height: 95px;
      justify-content: space-between;
      .number {
        font-size: 24px;
        color: #666;
        i {
          font-style: normal;
          color: #333;
        }
      }
      .status {
        font-size: 24px;
        color: #e42129;
      }
    }
    .bottom {
      width: 100%;
      text-align: right;
      span {
        font-size: 24px;
        color: #333;
        line-height: 50px;
        display: block;
        height: 50px;
        margin: 10px 0;
      }
      .s_li {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .item {
          width: 147px;
          height: 48px;
          border: 1Px solid #ccc;
          margin: 25px 0 25px 15px;
          line-height: 48px;
          text-align: center;
          border-radius: 8px;
          font-size: 24px;
          color: #161616;
          background: #fff;
        }
      }
    }
  }
  .pwd {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    .innerbox {
      background-color: #fff;
      height: 600px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
